import { all } from '@redux-saga/core/effects'

export default function* rootSaga() {
  yield all([])
  // code after all-effect
}
